import { render } from "./SubmissionDetail.vue?vue&type=template&id=2a399616&scoped=true"
import script from "./SubmissionDetail.vue?vue&type=script&lang=ts"
export * from "./SubmissionDetail.vue?vue&type=script&lang=ts"

import "./SubmissionDetail.vue?vue&type=style&index=0&id=2a399616&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2a399616"

export default script